// import _ from 'lodash'
import request from '@/utils/request'

const prefix = '/django_rest/role'

export default {
  getRoleList (params) {
    return request.get(`${prefix}/`, { params })
  },
  addRole (data) {
    return request.post(`${prefix}/`, data)
  },
  getPermissionsList (params) {
    return request.get(`${prefix}/permission/`, { params })
  },
  roleNameValidate (params) {
    return request.get(`${prefix}/validate/role_name/`, { params })
  },
  getRole (roleId, params) {
    return request.get(`${prefix}/${roleId}/`, { params })
  },
  updateRole (roleId, data) {
    return request.put(`${prefix}/${roleId}/`, data)
  },
  deleteRole (roleId) {
    return request.delete(`${prefix}/${roleId}/`)
  },
  exportRoleList (params) {
    return request.get(`${prefix}/list/export/`, { params })
  },
  saveRole (data) {
    return request.post(`${prefix}/`, data)
  },
  resetPassword (accountId) {
    return request.get(`${prefix}/${accountId}/reset-password/`)
  },
  roleEmailValidate (data) {
    return request.post(`${prefix}/validate/email/`, data)
  },
  roleMobileValidate (data) {
    return request.post(`${prefix}/validate/mobile/`, data)
  },
  getRoleDefaultInfo () {
    return request.get(`${prefix}/select-option/default-info/`)
  }
}
